import React, { useEffect, useState } from 'react';
import { getNotificationPreferences, updateNotificationPreferences } from '../services/pushApi';

const labels = {
  messages: 'Private messages',
  forumReplies: 'Forum replies',
  reactions: 'Reactions',
  announcements: 'Announcements and moderation updates',
  future: 'Future notification categories',
};

export default function NotificationPreferences() {
  const [values, setValues] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => { getNotificationPreferences().then(setValues).catch(() => setError('Unable to load notification preferences.')); }, []);
  const toggle = async (key) => {
    if (!values || busy) return;
    const next = { ...values, [key]: !values[key] };
    setValues(next); setBusy(true); setError('');
    try { setValues(await updateNotificationPreferences({ [key]: next[key] })); }
    catch { setValues(values); setError('Unable to save notification preferences.'); }
    finally { setBusy(false); }
  };
  return (
    <main style={{ minHeight: '100dvh', padding: 24, color: '#fff', background: '#12051f' }}>
      <section style={{ width: 'min(620px, 100%)', margin: '30px auto', padding: 24, border: '1px solid rgba(218,165,32,.4)', borderRadius: 18 }}>
        <h1>Notification preferences</h1>
        <p>Choose which notifications you want to receive on this account.</p>
        {error ? <p role="alert">{error}</p> : null}
        {!values ? <p role="status">Loading…</p> : Object.entries(labels).map(([key, label]) => (
          <label key={key} style={{ display: 'flex', justifyContent: 'space-between', gap: 16, padding: '14px 0' }}>
            <span>{label}</span><input type="checkbox" checked={values[key]} disabled={busy} onChange={() => toggle(key)} />
          </label>
        ))}
      </section>
    </main>
  );
}
